var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25,
    r: 25,
    fill: "#F1F1F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4496_95805)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 39C33.232 39 39.5 32.732 39.5 25C39.5 17.268 33.232 11 25.5 11C17.768 11 11.5 17.268 11.5 25C11.5 32.732 17.768 39 25.5 39ZM25.5 36.6667C31.9433 36.6667 37.1667 31.4433 37.1667 25C37.1667 18.5567 31.9433 13.3333 25.5 13.3333C19.0567 13.3333 13.8333 18.5567 13.8333 25C13.8333 31.4433 19.0567 36.6667 25.5 36.6667Z",
    fill: "#31313D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5629 28.4687C26.5307 28.4687 27.3129 27.6865 27.3129 26.7187L27.3129 17.9688C27.3129 17.001 26.5307 16.2188 25.5629 16.2188C24.5952 16.2187 23.8129 17.001 23.8129 17.9687L23.8129 26.7187C23.8129 27.6865 24.5952 28.4687 25.5629 28.4687ZM23.75 31.9687C23.75 32.954 24.548 33.7502 25.5315 33.7502C26.515 33.7502 27.313 32.954 27.313 31.9687C27.313 30.9852 26.515 30.1872 25.5315 30.1872C24.548 30.1872 23.75 30.9852 23.75 31.9687Z",
    fill: "#31313D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4496_95805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(11.5 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.8ff8f94758b4c90c4e602eedd131ed67.svg";
export { ForwardRef as ReactComponent };